/* file description */
import { Modal, Input, Tooltip, Button, Select, Table } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import React, { FC, useEffect, useState, useRef } from 'react';
import { getApiData, getOpenApiData } from '@/common/asset-apis/assetModel';
import { useTargetTableColumns, useLinShowModalSelect, useSetLabel, useGetLabelByEdit } from './effect';
import { COLUMN_FROM } from '../../effects/consts';
import { RecordSelectLinkShowModalProps } from './type';
import { cloneDeep } from 'lodash';
import memo from '../memo';

const { Search } = Input;

export const OpenApiSelectModal: FC<RecordSelectLinkShowModalProps> = ({
  API,
  field,
  value,
  onChange,
  form,
  config,
  columnFrom,
  storeValue,
  rowsData,
  disabled,
  moduleInfo,
  isMobile,
}) => {
  const { dispatchEvent, destroyEvent, taskInfo } = config.metaStore || {};
  const [apiParamsList, setapiParamsList] = useState({});
  const [status, setStatus] = useState<any>('');
  const [tableData, setTableData] = useState<any[]>([]);
  const { value: fieldName, isMulti, openApiUrl, apiKeyList, options, apiType = 'get' } = field?.options || {};
  // 回显值设置
  const { showLabel, setShowLabel, optionList, setOptionList } = useSetLabel();
  // 交互处理
  const { linkShowModalContrulor, showLinkShowModal, onSelectChange, onModalEnter, setInputLabel, selectedRowKeys, clickRow } = useLinShowModalSelect({ setShowLabel, API, isMulti, setOptionList });
  // 编辑时回显值处理
  useGetLabelByEdit({ value, field, form, config, columnFrom, setInputLabel, API, tableData });
  // column的处理
  const { targetTableColumns } = useTargetTableColumns({ field });
  const apiRef = useRef({});

  useEffect(() => {
    let headData: Record<any, any> = {};
    if (storeValue) {
      Object.keys(storeValue).forEach((key: any) => {
        if (!Array.isArray(storeValue[key])) {
          headData = storeValue[key];
        }
      });
    }
    if (columnFrom === COLUMN_FROM.TABLE) {
      if (rowsData?.[config.rowIndex]) {
        apiKeyList?.forEach((item: any) => {
          if (item.isValueFromMainModule) {
            apiRef.current = { ...apiRef.current, [item.apiKey]: headData?.[item.apiValueModule] };
          } else {
            apiRef.current = { ...apiRef.current, [item.apiKey]: rowsData?.[config.rowIndex]?.[item.apiValue] };
          }
        });
      }
    }
    if (columnFrom === COLUMN_FROM.FORM) {
      apiKeyList?.forEach((item: any) => {
        if (item.isValueFromMainModule) {
          apiRef.current = { ...apiRef.current, [item.apiKey]: headData?.[item.apiValueModule] };
        } else {
          apiRef.current = { ...apiRef.current, [item.apiKey]: config.formValue[item.apiValue] };
        }
      });
    }

    const mainModuleCode = taskInfo?.modules?.find(
      (module: any) => module.moduleID === taskInfo?.mainModuleId,
    )?.handle;
    const idList: any[] = [];
    apiKeyList?.forEach((item: any) => {
      const events = [{
        code: field.name,
        name: field.label,
        touchConfig: 'change',
        actionType: 'callback',
        moduleName: item.isValueFromMainModule ? mainModuleCode : moduleInfo.handle,
        fieldName: item.isValueFromMainModule ? item.apiValueModule : item.apiValue,
        rowIndex: config.rowIndex,
        fun: (value: any) => {
          apiRef.current = { ...apiRef.current, [item.apiKey]: value };
          setapiParamsList({ ...apiRef.current, [item.apiKey]: value });
        },
      }];
      const ids = dispatchEvent?.(events);
      idList.push(ids);
    });
    return () => {
      idList?.forEach((ids: any) => {
        destroyEvent?.(ids);
      });
    };
  }, []);

  // useEffect(() => {
  //   if (fieldError?.length > 0) {
  //     setStatus('error');
  //   } else {
  //     setStatus('');
  //   }
  // }, [fieldError]);

  useEffect(() => {
    const pass = apiKeyList.every((item: any) => apiRef.current[item.apiKey]);
    if (pass) {
      getOpenApiData(API?.FetchAPI, apiType, openApiUrl, apiRef.current).then((res: any) => {
        if (res?.length > 0 && !value) {
          onChange?.(res[0]?.[field?.options?.value]);
        }
        // 组件在table里时，apiParamsList会多触发一次, 可能会覆盖数据。在form里正常
        if (JSON.stringify(apiRef.current) !== '{}') {
          setTimeout(() => {
            setTableData(Array.isArray(res) ? (res || []) : []);
          }, 100);
        } else {
          setTableData(Array.isArray(res) ? (res || []) : []);
        }
      });
    }
  }, [JSON.stringify(apiRef.current)]);

  return (
    <>
      <div style={{ display: 'flex', minWidth: '100px' }}>
        <Select
          style={{ width: '100%' }}
          status={status}
          showArrow={false}
          filterOption={false}
          onChange={(val) => {
            onChange?.(val);
          }}
          notFoundContent="请点击放大镜搜索"
          value={value}
          options={optionList}
          fieldNames={{
            label: field?.options?.label,
            value: field?.options?.value,
          }}
          allowClear
          disabled={disabled}
        />
        <Button
          onClick={() => {
            linkShowModalContrulor(true);
          }}
          danger={status === 'error'}
          style={{ borderLeft: 'unset' }}
          icon={<SearchOutlined />}
          disabled={disabled}
        />
      </div>

      {showLinkShowModal &&
        <Modal
          zIndex={9999}
          visible
          onCancel={() => linkShowModalContrulor(false)}
          width={isMobile ? '95vw' : '70vw'}
          title="请选择"
          okText="确认选择"
          cancelText="取消"
          maskClosable={false}
          onOk={() =>
            onModalEnter({
              fieldName,
              onChange,
              form,
              config,
              field,
              columnFrom,
            })
          }
        >
          <Table
            rowSelection={{
              type: 'radio',
              selectedRowKeys,
              onChange: onSelectChange,
            }}
            rowKey={fieldName}
            onRow={(record: any) => ({
              onClick: () => {
                clickRow(record[fieldName], record);
              },
            })}
            size="small"
            dataSource={tableData}
            columns={targetTableColumns}
          />
        </Modal>
      }
    </>
  );
};
export default memo(OpenApiSelectModal);
